import { render, staticRenderFns } from "./MatchSheet.vue?vue&type=template&id=32211c22&scoped=true&"
import script from "./MatchSheet.vue?vue&type=script&lang=js&"
export * from "./MatchSheet.vue?vue&type=script&lang=js&"
import style0 from "./MatchSheet.vue?vue&type=style&index=0&id=32211c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32211c22",
  null
  
)

export default component.exports